import React, { useEffect, useMemo, useState } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faEllipsisVertical, faLock, faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
} from "react-table";


const ConfirmationLetterList = () => {
  const [data, setData] = useState([]);
  const [receiptMap, setReceiptMap] = useState({});
  const [loading, setLoading] = useState(false);
const sewadarId=localStorage.getItem('sewadarId')
  const token = localStorage.getItem("token");
  const centerCode = localStorage.getItem("code");
  const navigate = useNavigate();

  /* ---------------- FETCH CONFIRMATION LETTERS ---------------- */
  const fetchLetters = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get(`${SERVER_BASE}/confirmation-letter`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data || []);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load confirmation letters", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (row) => {
    const res = await Swal.fire({
      title: "Delete Confirmation Letter?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete",
    });
  
    if (!res.isConfirmed) return;
  
    // extract receiptIds from confirmation letter
    const receiptIds =
      Array.isArray(row.receipts)
        ? row.receipts.map(r => r.receiptId).filter(Boolean)
        : [];
  
    try {
      await apiClient.delete(
        `${SERVER_BASE}/deleteConfirmationLetter/${row.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          data: { receiptIds }, // 👈 SEND RECEIPT IDS
        }
      );
  
      Swal.fire({
        title: "Deleted",
        text: "Confirmation letter deleted.",
        icon: "success",
        toast: true,
        position: "top-right",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
  
      fetchLetters();
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to delete letter", "error");
    }
  };
  
  
  const fetchReceiptVouchers = async () => {
    try {
      const res = await apiClient.get(
        `${SERVER_BASE}/getReceiptVouchers/${centerCode}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const map = {};
      (res.data || []).forEach((rv) => {
        map[rv.id] = rv.ledgerName;
      });
      setReceiptMap(map);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchLetters();
    fetchReceiptVouchers();
  }, []);

  const handleEdit = (id) => {
    navigate("/confirmationLetter", { state: { letterId: id } });
  };

  const handleView = (id) => {
    navigate("/confirmationLetterPreview", { state: { letterId: id } });
  };

  const getLedgers = (receipts = []) => {
    if (!Array.isArray(receipts) || receipts.length === 0) return "—";
    return receipts
      .map((r) => receiptMap[r.receiptId])
      .filter(Boolean)
      .join(" || ");
  };
  const getRefPrefixByDate = (letterDate) => {
    const year = letterDate
      ? moment(letterDate).year()
      : moment().year();
  
    return `F.66.G Stores/RSSB/JP/RJ/${year}/`;
  };
  
  const columns = useMemo(
    () => [
      {
        Header: "#",
        width: 10,
        minWidth: 10,
        maxWidth: 10,
        accessor: (_, i) => i + 1,
        disableSortBy: true,
      },
      {
        Header: "Date",
        accessor: "letterDate",
        Cell: ({ value }) =>
          value ? moment(value).format("DD MMM YYYY") : "",
      },
      {
        Header: "Ref No",
        accessor: "refNo",
        Cell: ({ row }) => {
          const prefix = getRefPrefixByDate(row.original.letterDate);
      
          return (
            <span>
              {prefix}
              {row.original.refNo}
            </span>
          );
        },
      },
      
   
      {
        Header: "Ledger's",
        accessor: "receipts",
        width: 250,
        minWidth: 250,
        maxWidth: 250,
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!Array.isArray(value) || value.length == 0) {
            return <span className="text-muted">—</span>;
          }
      
          return (
            <ul className="mb-0 ps-3">
              {value.map((r, idx) => {
                const ledgerName = receiptMap[r.receiptId];
                if (!ledgerName) return null;
      
                return (
                  <li key={idx} style={{ fontSize: "12px", lineHeight: "1.4" }}>
                    {ledgerName}
                  </li>
                );
              })}
            </ul>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => (
          <span className="">
            {row.original.status =='Pending'?'Pending For Allocation':row.original.status}
          </span>
        ),
      },
      {
        Header: "Preview",
        accessor: "view",
        width: 40,
        minWidth: 40,
        maxWidth: 40,
        Cell: ({ row }) => {
          return(
            <div className="text-center">
            <button
            className="btn btn-sm btn-outline-success"
            onClick={() => handleView(row.original.id)}
          >
            View
          </button>
          </div>
        )},
      },
      {
        Header: "Edit",
        accessor: "edit",
        width: 90,
        minWidth: 90,
        maxWidth: 90,
        Cell: ({ row }) => {
          return(
      
              <div className="text-center">
            <button
              className="btn btn-sm btn-outline-success"
              onClick={() => handleEdit(row.original.id)}
              title="Edit"
            >
              <FontAwesomeIcon icon={faLock} />
            </button> 
            {sewadarId=='23' && (
            <button
            className="btn btn-sm btn-outline-danger ms-2"
            onClick={() => handleDelete(row.original)}
            title="Delete"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
          
            )}
</div>
        )},
      },
      
      {
        Header: "Created",
        accessor: "creator",
        Cell: ({ row }) => {
          const creator = row.original.creator;
          const updater = row.original.updater;
          return(
          <span className="">
             {creator
                      ? `${creator.firstName} ${creator.lastName}`
                      : ""} <br />
                      {row.original.createdAt
                      ? `${row.original.createdAt?moment(row.original.createdAt).format('DD MMM YY hh:mm A'):''} `
                      : ""} 

          </span>
        )},
      },
      {
        Header: "Updated",
        accessor: "updater",
        Cell: ({ row }) => {
          const updater = row.original.updater;
          return(
          <span className="">
             {updater
                      ? `${updater.firstName} ${updater.lastName}`
                      : ""}
                      <br />
                      {row.original.updatedAt
                      ? `${row.original.updatedAt?moment(row.original.updatedAt).format('DD MMM YY hh:mm A'):''} `
                      : ""} 
          </span>
        )},
      },
    ],
    [receiptMap]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state,
    setGlobalFilter,
    setPageSize,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 20 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { globalFilter, pageIndex, pageSize } = state;

  return (
    <div className="formcontainer mt-5">
      <div className="">
        <h5>Confirmation Letters</h5>

        <div className="card-body">
          {/* TOP CONTROLS */}
          <div className="row mb-3">
       
          <div className="col-md-3">
              <button
                className="btn btn-outline-success"
                onClick={() => {
                  navigate("../../confirmationLetter");
                }}
              >
                Generate Confirmation
              </button>
      </div>
            <div className="col-md-7">
              <input
                className="form-control"
                placeholder="Search..."
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <select
                className="form-select"
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                {[20,50,100,200].map((s) => (
                  <option key={s} value={s}>
                    Show {s}
                  </option>
                ))}
              </select>
            </div>  
          </div>

          {/* TABLE */}
          <table
            className="table table-bordered table-hover align-middle"
            {...getTableProps()}
            style={{fontSize:'12px'}}
          >
            <thead className="table-light">
              {headerGroups.map((hg) => (
                <tr {...hg.getHeaderGroupProps()}>
                  {hg.headers.map((col) => (
                    <th
                      {...col.getHeaderProps(col.getSortByToggleProps())}
                      style={{
                        cursor: "pointer",
                        width: col.width,
                        minWidth: col.minWidth,
                        maxWidth: col.maxWidth,
                      }}
                    >
                      {col.render("Header")}
                      {col.isSorted &&
                        (col.isSortedDesc ? " 🔽" : " 🔼")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {loading ? (
                <tr>
                  <td colSpan={columns.length} className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : page.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="text-center">
                    No confirmation letters found
                  </td>
                </tr>
              ) : (
                page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>

          {/* BOTTOM PAGINATION */}
        
        
            <div className="d-flex align-items-center mb-3">
              {/* Previous – left corner */}
              <button
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                className="btn btn-secondary me-auto"
                style={{ minWidth: 110 }} // keeps width consistent
              >
                Previous
              </button>

              {/* Center block for page index & size selector */}
              <div className="text-center flex-grow-1 d-flex flex-column align-items-center">
                {/* Row 1: Page index and size selector in one line */}
                <div className="d-flex align-items-center gap-3">
                  <div className="fw-semibold">
                    Page {pageIndex + 1} of {pageOptions.length}
                  </div>
                </div>
              </div>

              {/* Next – right corner */}
              <button
                onClick={() => nextPage()}
                disabled={!canNextPage}
                className="btn btn-secondary ms-auto"
                style={{ minWidth: 110 }}
              >
                Next
              </button>
            </div>
          </div>
      </div>
    </div>
  );
};

export default ConfirmationLetterList;
